import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Kata sandi berhasil diperbarui. Silakan masuk.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 bg-white p-8 rounded-2xl shadow-xl">
        <h1 className="font-heading text-2xl font-bold text-navy">Reset Kata Sandi</h1>
        {!token ? (
          <p className="text-sm text-primary">Token tidak ditemukan.</p>
        ) : (
          <>
            {error && <div className="text-sm text-primary">{error}</div>}
            <div className="space-y-1.5">
              <Label>Kata Sandi Baru</Label>
              <Input type="password" data-testid="reset-password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />
            </div>
            <Button type="submit" data-testid="reset-submit" className="w-full bg-primary hover:bg-red-700">Simpan Kata Sandi</Button>
          </>
        )}
        <div className="text-center">
          <Link to="/login" className="text-xs text-muted-foreground hover:text-primary">Kembali ke Masuk</Link>
        </div>
      </form>
    </div>
  );
}
